<template>
  <v-container fluid class="saleschannel-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Channel
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">Edit Channel</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeChannel($event, 'channelcode')"
                        v-bind:value="initvalue.channelcode"
                        placeholder="Channel Code"
                        persistent-hint
                        single-line hint="Enter the channel code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeChannel($event, 'channelname')"
                        v-bind:value="initvalue.channelname"
                        placeholder="Channel Name"
                        persistent-hint
                        single-line hint="Enter the channel name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeChannel($event, 'channelinfo')"
                        v-bind:value="initvalue.channelinfo"
                        placeholder="Channel Info"
                        persistent-hint
                        single-line hint="Enter the channel info">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['Channel', 'Other Channel']"
                        :value="initvalue.channeltype"
                        outlined
                        dense
                        v-on:change="onChangeChannel($event, 'channeltype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the channel type">
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="4">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/saleschannel/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editSalesChannel()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/saleschannel/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      change_channel: {},
      detail: {},
      photo: {},
      
      filename: null,
      initvalue: {},
      imageurl: undefined,
      upload: {},
    }
  },
  methods: {
    ...mapActions('SalesChannel', ['updateSalesChannelRequest','updateSalesChannelImageRequest','updateSalesChannelPinRequest','getSalesChannelsRequest']),
    async editSalesChannel() {
      this.change_channel._id = this.initvalue._id;
      await this.updateSalesChannelRequest(this.change_channel);
      router.push('/saleschannel/list');
    },
    async editPhoto() {
      this.photo._id = this.initvalue._id;
      await this.updateSalesChannelImageRequest(this.photo);
      router.push('/saleschannel/list');
    },
    onChangeChannel(value, field){
      this.change_channel[field] = value;
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.photo.channelimage = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.channelimage = file;
      this.upload.imagename = file.name;
      console.log(this.upload);
    },
  },
  computed: {
    ...mapState('SalesChannel', ['isReceiving'])
  },
  async created () {
    this.initvalue = this.$route.params;
    this.imageurl = this.initvalue.channelimage;
    if(!this.initvalue._id) this.$router.push({ name: 'SalesChannelList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
